export default __webpack_public_path__ + "static/folia-image-fb587101ba100a7d1c8f1a68771b47ff.png";